import { CongestionLevels } from './congestionLevels';
import { NETWORK_CONDITION, NETWORK_CONDITION_REASON } from '../../../helpers/networkConditionConstants';

const LIMITS = {
  FROM_GOOD_TO_FAIR: 0.6,
  KEEP_IN_FAIR: 0.7,
  KEEP_IN_EXCELLENT: 0.8,
  FROM_GOOD_TO_EXCELLENT: 0.9,
};

const calculateNetworkCondition = ({
  congestionLevel,
  congestionReason,
  videoWidth,
  videoHeight,
  videoFramesPerSecond,
  videoSourceWidth,
  videoSourceHeight,
  videoSourceFramesPerSecond,
  prevNetworkCondition,
}) => {
  if (congestionLevel !== CongestionLevels.LOW) {
    return {
      networkCondition: congestionLevel === CongestionLevels.MEDIUM
        ? NETWORK_CONDITION.WARNING : NETWORK_CONDITION.CRITICAL,
      networkConditionReason: congestionReason,
    };
  }
  if (
    videoWidth < videoSourceWidth ||
    videoHeight < videoSourceHeight
  ) {
    return {
      networkCondition: NETWORK_CONDITION.FAIR,
      networkConditionReason: NETWORK_CONDITION_REASON.BANDWIDTH,
    };
  }
  if (videoFramesPerSecond) {
    let factor =
      prevNetworkCondition === NETWORK_CONDITION.GOOD ||
      prevNetworkCondition === NETWORK_CONDITION.EXCELLENT
        ? LIMITS.FROM_GOOD_TO_FAIR : LIMITS.KEEP_IN_FAIR;
    if (videoFramesPerSecond < factor * videoSourceFramesPerSecond) {
      return {
        networkCondition: NETWORK_CONDITION.FAIR,
        networkConditionReason: NETWORK_CONDITION_REASON.BANDWIDTH,
      };
    }
    factor = prevNetworkCondition === NETWORK_CONDITION.EXCELLENT
      ? LIMITS.KEEP_IN_EXCELLENT : LIMITS.FROM_GOOD_TO_EXCELLENT;
    if (videoFramesPerSecond > factor * videoSourceFramesPerSecond) {
      return {
        networkCondition: NETWORK_CONDITION.EXCELLENT,
        networkConditionReason: NETWORK_CONDITION_REASON.NONE,
      };
    }
  }
  return {
    networkCondition: NETWORK_CONDITION.GOOD,
    networkConditionReason: NETWORK_CONDITION_REASON.NONE,
  };
};

export default calculateNetworkCondition;
